/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Results_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to share results" |
*
* @param {Share_Results_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const share_results_error = /** @type {((inputs?: Share_Results_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Results_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du partage des résultats")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al compartir los resultados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao compartilhar os resultados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile condividere i risultati")
	return /** @type {LocalizedString} */ ("Failed to share results")
});